import { render, staticRenderFns } from "./BorderRadius.vue?vue&type=template&id=7354e74e&"
import script from "./BorderRadius.vue?vue&type=script&lang=ts&"
export * from "./BorderRadius.vue?vue&type=script&lang=ts&"
import style0 from "./BorderRadius.vue?vue&type=style&index=0&id=7354e74e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports